(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SessionExternalTeamPickerController', SessionExternalTeamPickerController);

    /* @ngInject */
    function SessionExternalTeamPickerController(
        $mdDialog,
        Team,
        ParseLinks,
        AlertService,
        paginationConstants,
        selectedTeams
    ) {
        var vm = this;

        vm.teams = [];
        vm.page = 1;
        vm.queryCount = 0;
        vm.totalItems = 0;
        vm.links = {};
        vm.promise = null;
        vm.isLoading = false;
        vm.selectAll = false;
        vm.filter = {
            show: false,
            options: {
                debounce: 400
            }
        };
        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage || 20,
            page: 1
        };

        // Selected teams with maskUsers flag (default true per Figma)
        vm.selectedTeams = angular.copy(selectedTeams || []).map(function(team) {
            return {
                id: team.id,
                name: team.name,
                member_count: team.member_count,
                maskUsers: team.maskUsers !== false
            };
        });

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.isSelected = isSelected;
        vm.toggleTeam = toggleTeam;
        vm.toggleSelectAllOnPage = toggleSelectAllOnPage;
        vm.removeSelected = removeSelected;
        vm.removeFilter = removeFilter;
        vm.close = close;
        vm.done = done;
        vm.getMemberCountLabel = getMemberCountLabel;

        loadAll();

        function getQueryString() {
            var query = 'status==ACTIVE';
            if (vm.query.filter && vm.query.filter.length > 0) {
                query += ';name=re="' + vm.query.filter + '"';
            }
            return query;
        }

        function loadAll() {
            vm.isLoading = true;
            vm.promise = Team.query({
                page: 0,
                size: vm.query.limit,
                sort: ['name,asc'],
                query: getQueryString()
            }, onSuccess, onError).$promise;

            vm.promise.finally(function() {
                vm.isLoading = false;
            });

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.teams = data || [];
                vm.page = 1;
                syncSelectAllState();
            }

            function onError(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : error);
            }
        }

        function transition() {
            vm.isLoading = true;
            vm.promise = Team.query({
                page: vm.page - 1,
                size: vm.query.limit,
                sort: ['name,asc'],
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data) {
                vm.teams = data || [];
                syncSelectAllState();
            }).finally(function() {
                vm.isLoading = false;
            });
        }

        function findSelectedIndex(teamId) {
            for (var i = 0; i < vm.selectedTeams.length; i++) {
                if (vm.selectedTeams[i].id === teamId) {
                    return i;
                }
            }
            return -1;
        }

        function isSelected(team) {
            return findSelectedIndex(team.id) >= 0;
        }

        function toggleTeam(team) {
            var index = findSelectedIndex(team.id);
            if (index >= 0) {
                vm.selectedTeams.splice(index, 1);
            } else {
                vm.selectedTeams.push({
                    id: team.id,
                    name: team.name,
                    member_count: team.member_count,
                    maskUsers: true
                });
            }
            syncSelectAllState();
        }

        function toggleSelectAllOnPage() {
            if (vm.selectAll) {
                angular.forEach(vm.teams, function(team) {
                    if (!isSelected(team)) {
                        vm.selectedTeams.push({
                            id: team.id,
                            name: team.name,
                            member_count: team.member_count,
                            maskUsers: true
                        });
                    }
                });
            } else {
                angular.forEach(vm.teams, function(team) {
                    var index = findSelectedIndex(team.id);
                    if (index >= 0) {
                        vm.selectedTeams.splice(index, 1);
                    }
                });
            }
        }

        function syncSelectAllState() {
            if (!vm.teams || vm.teams.length === 0) {
                vm.selectAll = false;
                return;
            }
            vm.selectAll = vm.teams.every(function(team) {
                return isSelected(team);
            });
        }

        function removeSelected(team) {
            var index = findSelectedIndex(team.id);
            if (index >= 0) {
                vm.selectedTeams.splice(index, 1);
                syncSelectAllState();
            }
        }

        function getMemberCountLabel(team) {
            var count = team.member_count != null ? team.member_count : 0;
            return count === 1 ? (count + ' user') : (count + ' users');
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            loadAll();
        }

        function close() {
            $mdDialog.cancel();
        }

        function done() {
            $mdDialog.hide(angular.copy(vm.selectedTeams));
        }
    }
})();
